import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { Typography } from '../../../atoms/typography';
import { useList } from '../list.context';

import * as styles from './base-list-item.styles';

type Props = {
  hasGap: boolean;
  icon: ReactNode;
  children: ReactNode;
};

export const BaseListItem = ({ hasGap, icon, children, ...rest }: Props) => {
  const { variant } = useList();
  const theme = useTheme();

  return (
    <li css={[styles.root, hasGap && styles.gap(theme)]} data-testid="base-list-item" {...rest}>
      <span aria-hidden="true" css={styles.iconWrapper[variant](theme)}>
        {icon}
      </span>
      <Typography color="textSecondary" variant={variant === 'medium' ? 'b2' : 'b3'}>
        {children}
      </Typography>
    </li>
  );
};
